<!--
 * @Description: 
 * @version: 
 * @Author: 李云飞
 * @Date: 2023-07-14 17:42:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-11 10:56:38
-->
<template>
  <a-menu mode="inline" theme="dark" :selectedKeys="menuSelectedKeys" :openKeys="menuOpenKeys" @click="clickMenu">
    <AsideMenuList :menuList="menuList" />
  </a-menu>
</template>

<script setup>
import { onMounted, reactive, ref, computed, watch } from 'vue';
import { useUserStore } from '@/store/user.js';
import { useRoute, useRouter } from 'vue-router';
import { staticRoutes } from '@/router/routes.js';
import { MENU_TYPE_ENUM } from '@/constants/system';
import localStorageKeyConst from '@/constants/local-storage-key-const';
import lodash from 'lodash';
import AsideMenuList from './AsideMenuList.vue';
const { HOME_PAGE } = localStorageKeyConst;

// 动态菜单数据
const getUserMenuList = computed(() => useUserStore().getUserMenuList);

// 构建菜单列表
const menuList = computed(() => {
  const menuData = buildMenuData(getUserMenuList.value);
  const result = setMenuList([...staticRoutes, ...menuData]);
  result.sort((a, b) => a.sort - b.sort)
  return result;
});

function buildMenuData(menuList = [], rootParentId = 0) {
  const map = {};
  const result = [];
  for (const item of menuList) {
    item.name = item.path;
    item.meta = {
      title: item.menuName,
      icon: item.icon,
    };
    if (item.menuType === MENU_TYPE_ENUM.MENU.value) {
      item.meta.keepAlive = item.keepAliveFlag;
      item.meta.hideMenuFlag = item.hideMenuFlag;
    }
    map[item.menuId] = { ...item };
  }
  for (const item of menuList) {
    const node = map[item.menuId];
    if (item.parentId === rootParentId) {
      result.push(node);
    } else {
      const parent = map[item.parentId];
      if (parent) {
        if (parent.children) {
          parent.children.push(node);
        } else {
          parent.children = [node];
        }
      }
    }
  }
  return result;
}

function setMenuList(list) {
  const result = [];
  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (!item.meta.hideMenuFlag) {
      result.push(item);
    }
    if (!lodash.isEmpty(item.children)) {
      item.children = setMenuList(item.children);
    }
  }
  return result;
}

// 菜单路由跳转
const router = useRouter();
function clickMenu({ item, key, keyPath }) {
  router.push({ path: key });
}

// 菜单选中状态
const route = useRoute();
const menuSelectedKeys = computed(() => {
  return [route.path];
});

// 菜单展开状态
const menuOpenKeys = ref([]);

watch(
  () => route,
  (newVal) => {
    if (newVal.name === HOME_PAGE) {
      menuOpenKeys.value = [];
      return;
    }
    getOpenKeys(newVal);
  },
  { deep: true, immediate: true }
);

function getOpenKeys(routeInfo) {
  const list = lodash.cloneDeep(getUserMenuList.value);
  const map = {};
  for (const item of list) {
    map[item.menuId] = { ...item };
  }
  const resultList = [];
  const findItem = list.find((item) => item.path === routeInfo.path);
  if (findItem) {
    findParentPath(map, findItem, resultList);
  }
  menuOpenKeys.value = resultList;
}

function findParentPath(map, item, resultList) {
  if (item.parentId) {
    const parentItem = map[item.parentId];
    resultList.unshift(parentItem.path);
    if (parentItem.parentId) {
      findParentPath(map, parentItem, resultList);
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep(.ant-menu-item) {
  background: rgba(#001529, 0.5);
  margin-top: 0;
  margin-bottom: 0;
}
</style>
